// extracted by mini-css-extract-plugin
export default {"root":"NotFoundFilter_root__2Z73V","description":"NotFoundFilter_description__tGLQE"};